import { wellControlInstance } from './api';

export const getAssetCommunicationAccess = async (): Promise<boolean> => {
  try {
    const response = await wellControlInstance.get('/WellControl/hasAssetCommunicationAccess');
    return !!response.data?.hasAssetCommunicationAccess;
  } catch {
    return false;
  }
};
